module.exports = __webpack_public_path__ + "img/Butterfly_00179.5494af88.png";